module.exports = __webpack_public_path__ + "img/3.dd1a47d5.png";